import React from "react";
import Chart from "react-apexcharts";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";
import { encrypt } from "../Utils/Encryption";

const contrastColors = [
  "#5B9BD5", "#70AD47", "#FFC000", "#ED7D31", "#A5A5A5",
  "#4472C4", "#E2725B", "#7FB3D5", "#C5E0B4", "#F4B084"
]
const DashboardPieChart = ({ metricData, status }) => {
  const chartData = JSON.parse(metricData.coordinates || "{}");
  const valueType = chartData?.datasets?.[0]?.value_type ?? "";

  const formatValue = (val) => {
    let formatted = val;
    if (typeof val === "number" && !Number.isInteger(val)) {
      formatted = val.toFixed(2);
    }
    if (valueType === "Nos") {
      return `${formatted} Nos`;
    }
    if (valueType) {
      return `${valueType}${formatted}`;
    }
    return formatted;
  };

  const aggregatedData = metricData.value.reduce((acc, item) => {
    const name = item.name;
    const value = parseFloat(item.value);

    acc[name] = (acc[name] || 0) + value;
    return acc;
  }, {});

  const labels = Object.keys(aggregatedData);
  const series = Object.values(aggregatedData);

  const pieColors = contrastColors.slice(0, series.length);

  const options = {
    chart: {
      type: "pie",
    },
    labels: labels,
    colors: pieColors,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      show: true,
      position: "right",
      horizontalAlign: "right",
      floating: false,
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
      formatter: function (seriesName, opts) {
        const value = opts.w.globals.series[opts.seriesIndex];
        return `${seriesName}`;
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        fontWeight: "bold",
      },
      formatter: function (val, opts) {
        const value = opts.w.globals.series[opts.seriesIndex];
        return `${formatValue(value)} (${Math.round(val)}%)`;
      },
    },
    tooltip: {
      y: {
        formatter: formatValue,
      },
    },
  };

  return (
    <div className="col-12 h-100 ChartData">
      <div className="dashboardCharttitleContainer">
        {metricData?.child && status == 1 && metricData?.metric_id ? (
          <Link
            to={`/dashboard/childmetric/${metricData.metric_name}/${encrypt(
              metricData.metric_id.toString()
            )}/1`}
            className="dashboardCharttitle dashboardCharttitleActive"
          >
            <span className="text-md">{metricData.metric_name}</span>
            <GoLinkExternal className="externelLink" />
          </Link>
        ) : (
          <div className="dashboardCharttitle">
            <span className="text-md">{metricData?.metric_name}</span>
          </div>
        )}
      </div>
      <div className="dashboardChart">
        <Chart
          options={options}
          series={series}
          className="charts"
          type="pie"
          width="100%"
          height={350}
        />
      </div>
    </div>
  );
};

export default DashboardPieChart;
